import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpSimpleTableComponent from './adpSimpleTable.component';

let adpSimpleTableModule = angular.module('adpSimpleTable', [
  uiRouter
])

.component('adpSimpleTable', adpSimpleTableComponent)

.name;

export default adpSimpleTableModule;



// WEBPACK FOOTER //
// ./src/app/components/adpSimpleTable/adpSimpleTable.js